module.exports = __webpack_public_path__ + "img/56.2c2e5928.png";